import { ConsultationComponent } from './consultation.component';
import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { ConsultationEditComponent } from './consultation-edit/consultation-edit.component';

export const consultationsRoutes: Routes = [
  {
    path: 'consultation',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: ':consultationId/edit',
        component: ConsultationEditComponent,
      },
      {
        path: '',
        component: ConsultationComponent
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/consultation/consultation.routes.ts